import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedRmBuddyId,
  searchTasksByOrderNumberOrServiceReqId
} from "../../../redux/rm-buddies/actions";
import "./style.less";
import WarehouseSelector from "../WarehouseSelector";
import TasksDueDateSelector from "../TasksDueDateSelector";
import { TasksTabs } from "../TasksTabs";
import { Input, Form } from "semantic-ui-react";
import TaskSearchResultsTab from "../TaskSearchResultsTab";
import { useParams } from "react-router-dom";
import { setCurrentRmBuddiesWarehouseId } from "../../../redux/rm-buddies/actions";

function WarehouseTasksView() {
  const { warehouseId } = useParams();
  const dispatch = useDispatch();
  const currentWarehouseId = useSelector(
    ({ rmBuddies }) => rmBuddies.currentWarehouseId
  );
  const taskSearchResults = useSelector(
    ({ rmBuddies }) => rmBuddies.taskSearchResults
  );
  const [orderNumberOrReqId, setOrderNumberOrReqId] = useState("");
  const searchSubmitHandler = useCallback(() => {
    dispatch(searchTasksByOrderNumberOrServiceReqId(orderNumberOrReqId));
  }, [orderNumberOrReqId, dispatch]);
  useEffect(() => {
    dispatch(setSelectedRmBuddyId(null));
  }, [dispatch]);
  useEffect(() => {
    dispatch(setCurrentRmBuddiesWarehouseId(warehouseId));
  }, [warehouseId, dispatch]);

  useEffect(() => {
    if (!taskSearchResults) {
      setOrderNumberOrReqId("");
    }
  }, [taskSearchResults, setOrderNumberOrReqId]);

  return (
    <div className="WarehouseTasksView">
      <WarehouseSelector className="WarehouseSelectorDropdown" />
      {currentWarehouseId && (
        <Form className="TasksSearchBar" onSubmit={searchSubmitHandler}>
          <Input
            icon="search"
            placeholder="Search by Order Number"
            value={orderNumberOrReqId}
            onChange={e => setOrderNumberOrReqId(e.target.value)}
          />
        </Form>
      )}
      {currentWarehouseId && !taskSearchResults && (
        <div>
          <TasksDueDateSelector />
          <TasksTabs />
        </div>
      )}

      {taskSearchResults && (
        <div>
          <br />
          <TaskSearchResultsTab
            orderNumberOrReqId={orderNumberOrReqId}
            searchResults={taskSearchResults}
            onClose={() => setOrderNumberOrReqId("")}
          />
        </div>
      )}
    </div>
  );
}

export default WarehouseTasksView;
